import { apiClient, type ApiClientResponse, routes } from 'common/services';
import { type CommunityDataObject } from 'models/service';

export const getCommunity = async ({ id, invitationToken }: { id: string; invitationToken?: string }) => {
  return apiClient.get<CommunityDataObject, ApiClientResponse<CommunityDataObject>>(routes.community.get(id), {
    // eslint-disable-next-line @typescript-eslint/naming-convention -- We missing correct application model in camelCase, we need to fix it
    params: { invitation_token: invitationToken },
  });
};
